import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Layers3, ArrowLeft } from "lucide-react";
import { formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../context/LangContext";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useLang();
  useDocumentTitle(t("Entrar · ReiMultiBlog", "Sign in · ReiMultiBlog"));
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(t("Bem-vindo!", "Welcome!"));
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative overflow-hidden border-r border-white/10">
        <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
        <div className="absolute bottom-0 p-12">
          <h2 className="font-heading text-4xl font-extrabold max-w-sm leading-tight">{t("Centro de comando de conteúdo", "Content command center")}</h2>
          <p className="mt-3 text-muted-foreground max-w-sm">{t("Gera, revê e publica nos teus blogs a partir de um só painel.", "Generate, review and publish across your blogs from one panel.")}</p>
        </div>
      </div>
      <div className="grid place-items-center px-4">
        <div className="w-full max-w-md">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8"><ArrowLeft className="h-4 w-4" />{t("Início", "Home")}</Link>
          <div className="flex items-center gap-2 mb-6">
            <span className="grid h-9 w-9 place-items-center overflow-hidden rounded-xl"><img src="/logo.png" alt="ReiMultiBlog" className="h-9 w-9 object-cover" /></span>
            <span className="font-heading text-lg font-extrabold">Rei<span className="text-primary">MultiBlog</span></span>
          </div>
          <h1 className="font-heading text-2xl font-bold">{t("Entrar no painel", "Sign in to dashboard")}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t("Autenticação interna (sem Supabase Auth).", "Internal auth (no Supabase Auth).")}</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" placeholder="admin@grouprei.com" />
            </div>
            <div>
              <Label>{t("Palavra-passe", "Password")}</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
            </div>
            <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full">
              {loading ? t("A entrar…", "Signing in…") : t("Entrar", "Sign in")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
